<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12 sm12 md12 lg12)
      v-layout.subheader-policyinfo(row wrap)
        v-flex.first(xs12 sm12 md6 lg6)
          v-layout(row wrap)
            v-flex(xs2 sm2 md1 lg1)
              img.icon-cliente(:src="icons.cliente" alt="icons-cliente")
            v-flex.text-client-policy(xs10 sm10 md11 lg11)
              h2 {{ title }}
              p Este es el resumen de tu póliza
    //- code {{ guaranteed }}
    form-desktop-masivo(:masivo="guaranteed" v-if="$vuetify.breakpoint.mdAndUp")
    form-mobile-masivo(:masivo="guaranteed" v-if="$vuetify.breakpoint.smAndDown")
</template>

<script>
import FormDesktopMasivo from '@/components/masivos/FormDesktopMasivo'
import FormMobileMasivo from '@/components/masivos/FormMobileMasivo'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      title: '',
      icons: {
        cliente: require('./../assets/vida-icons/icon-cliente.svg')
      }
    }
  },
  props: ['guaranteed'],
  methods: {
    ...mapActions('user', ['checkJWT', 'getPDFPolizaElectronica'])
  },
  mounted () {
    this.checkJWT()
    this.title = 'Hola ' + this.userInfo.nombreUsuario.split(' ')[0]
  },
  computed: {
    ...mapGetters('user', ['userInfo'])
  },
  components: {
    'form-desktop-masivo': FormDesktopMasivo,
    'form-mobile-masivo': FormMobileMasivo
  }
}
</script>

<style>
  /** ESTILO 3 */
  #guaranteed .container.grid-list-md {
    padding-top: 0;
    padding-bottom: 0;
  }
  .subheader-policyinfo {
    border-bottom: #DEDEDE 1px solid;
    margin-bottom: 2em !important;
    padding-bottom: 10px;
  }
  .subheader-policyinfo img.icon-cliente {
    width: 42px;
    position: relative;
    top: 10px;
  }
  .subheader-policyinfo .text-client-policy { padding-left: 11px !important; }
  .subheader-policyinfo .flex h2 {
    font-size: 28px;
    line-height: 1.2;
  }
  .subheader-policyinfo .flex h2, .subheader-policyinfo .flex p strong {
    color: #1F1F1F;
    font-weight: normal;
  }
  .subheader-policyinfo .flex p strong { font-family: 'Omnes Medium' }
  .subheader-policyinfo .flex p {
    color: #717285;
    margin-bottom: 0;
  }
  .layout.subheader-policyinfo .flex.global-info-policy {
    text-align: right;
    padding-top: 39px;
  }
  .subheader-policyinfo .global-info-policy p { display: inline-block; }
  .subheader-policyinfo .global-info-policy p:first-child { margin-right: 3em; }
  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {
    /** NEW STYLE V3 */
    .contain-estado-cuenta .layout .flex:first-child { padding-right: 5px; }
    .contain-estado-cuenta .layout .flex:first-child + .flex { padding-left: 5px; }
    .v-btn.download-btn-files, #btnDownloadEstado {
      background-color: var(--fuchsia-color) !important;
      color: #fff;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      height: auto;
      width: 100%;
      margin: 0;
      text-transform: none;
      padding: 10px 0;
    }
    #btnDownloadEstado.v-btn.v-btn--disabled {
      background-color: rgba(0,0,0,.12)!important;
    }
    /** ESTADO DE CUENTA */
    #guaranteed .container { padding: 0; }
    .v-dialog--fullscreen #guaranteed { padding: 16px 0 0 0; }
    .subheader-policyinfo img.icon-cliente {
      width: 44px;
      position: relative;
      top: 5px;
      left: 5px;
    }
    .subheader-policyinfo .text-client-policy { padding: 0 !important; }
    .subheader-policyinfo {
      margin-bottom: 0 !important;
      padding-bottom: 0;
      border-bottom: #DEDEDE 12px solid;
    }
    .layout.subheader-policyinfo .flex.first:first-child {
      padding: 7px 16px 24px 16px;
    }
    #guaranteed .layout.subheader-policyinfo .flex.global-info-policy {
      padding: 8px 16px;
      border-top: #DEDEDE 1px solid;
    }
    #guaranteed .layout.subheader-policyinfo .flex.global-info-policy p:first-child {
      padding: 0;
      float: left;
      margin: 0;
      text-align: left;
    }
    #guaranteed .layout.subheader-policyinfo .flex.global-info-policy p:first-child + p {
      padding: 0;
      float: right;
      margin: 0;
      text-align: left;
    }
    /** NEW STYLE V3 */
  }
  /* Large tablet to laptop ----------- */
  @media only screen  and (min-width : 961px) and (max-width: 1264px) {}

  /* Desktop ----------- */
  @media only screen  and (min-width : 1265px) {
    .subheader-policyinfo .first .layout .flex:first-child { text-align: center; }
  }
</style>



// WEBPACK FOOTER //
// src/components/FormMasivo.vue